<template>
  <div class="dynamic-content">
    <basiCcontainer ref="content" @loadMore="loadMore" @onscroll="init">
      <template #head v-if="!reference">
        <div class="head-parent" >
          <div class="left">动态</div>
          <FilterBox @timeChange="timeChange" @projectChange="projectChange"></FilterBox>
        </div>
      </template>
      <div class="content-box-dynamic" :class="{'line-not': reference}">
        <div class="date-box" v-if="!reference">
          <dateSelect :idx="idx" :time="time" @selectNode="selectNode" />
        </div>
        <div class="project-time-line" ref="projectTimeLine" >
          <div class="time-line-box" v-for="(item, val) in computedDataList" :key="'foolw2' + val">
            <div class="time" :class="{'lightColor': val === time[idx]}" >{{resetTime(val)}}</div>
            <div class="time-line-item" v-for="(key, title) in item" :key="'foolw1' + title">
              <div class="title text-blue" @click="linkToTaskList(item[title])">{{title}}</div>
              <div class="dynamic-log">
                <div class="dynamic-log-item" v-for="(innerItem,index) in key" :key="'foolw' + index">
                  <div class="dynamic-log-item__in">
                    <span class="log-time">{{new Date(innerItem.create_time) | formatOnlyTime}}</span>
                    <toolTip :title="innerItem.message_sender_user.realname" class="log-user" maxWidth="66px"><span>{{innerItem.message_sender_user.realname}}</span></toolTip>
                    <div class="message-model" @click="messageHasClick($event,innerItem, true)" v-html="getTaskModel(innerItem, true)"></div>
                  </div>
                  <div class="real-tip">
                    <span v-if="innerItem.task" class="text-blue" :class="{'not-click': innerItem.raw_data.action === 'delete_task'}" @click="openMessageTask(innerItem)"><i class="icon iconfont iconicon_task_message2"></i>{{innerItem.task.task_name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p v-if="loading" class="loading-box-p" v-loading="loading"></p>
      </div>
      <p class="loadding-text" v-if="noMore && computedDataList && Object.getOwnPropertyNames(computedDataList).length  > 0">— 没有更多了 —</p>
      <nothing v-if="(computedDataList && Object.getOwnPropertyNames(computedDataList).length === 0) && !loading" :config="{tip:'暂无最新动态',type:'img_no_news_notification'}"></nothing>
    </basiCcontainer>
  </div>
</template>
<script>
import api from "@/services/api/dynamic/dynamic";
import mineApi from '@/services/api/mine/mine'
import dayjs from "dayjs";
export function formatDate(timestamp) {
  return dayjs(timestamp).format("YYYY-MM-DD");
}
export function formatTime(timestamp) {
  return dayjs(timestamp).format("HH:mm");
}
import dateSelect from './dateSelect'
// import AddTask from "@/views/task/addTask/index.vue";
import { mapActions, mapMutations } from 'vuex'
import bus from '@/bus'
import FilterBox from './filterBox'
export default {
  props: {
    //是否为引用组件
    reference: {
      type: Boolean,
      default: false
    }
  },
  name: "",
  components: {
    dateSelect,
    FilterBox
    // AddTask
  },
  data() {
    return {
      dataList: [],
      page: 1,
      limit: 30,
      time: [],
      loading: true,
      noMore: false,
      eleListData: [],
      timer: '',
      idx: 0,
      isCheck: false,
      i: 0,
      visibleTaskInfo: false,
      task_id: '',
      project_id: '',
      task_list_id: '',
      contentHeight: 0,
      start_time: '',
      end_time: ''
    };
  },
  created() {
    this.ready()
    bus.$on('updateTask', () => {
      this.ready()
    })
  },
  destroyed() {
    bus.$off('updateTask')
  },
  computed: {
    computedDataList() {
      return this.groupData(this.dataList);
    },
  },
  filters: {
    formatHHMMSS(time) {
      return formatTime(time * 1000);
    }
  },
  mounted() {

  },
  methods: {
    ready() {
      this.page = 1
      this.loading = false
      this.noMore = false
      this.dataList = []
      this.fetchDynamicList();
    },
    init(scrolltop) {
      if (this.isCheck) { return }
      clearInterval(this.timer)
      this.timer = ''
      this.timer = setInterval(() => {
        let num = scrolltop
        this.eleListData.find((res, index) => {
          if (num < res.max - 100) {
            this.idx = index * 1
            return true
          }
        })
        clearInterval(this.timer)
        this.timer = ''
      }, 300)
    },
    linkToTaskList(data) {
      this.$router.push('/task?isTabShow=true&projectId=' + data[0].project.project_id)
    },
    fetchDynamicList() {
      this.loading = true
      return api.getDynamicList({
        project_id: this.project_id,
        start_time: this.start_time,
        end_time: this.end_time,
        page: this.page,
        number: this.limit
      }).then(res => {
        this.dataList = [...this.dataList, ...res.data];
        this.total = res.total;
        this.loading = false
        if (res.data.length == 0) {
          this.noMore = true
        }
        this.eleListData = []
        if (this.dataList.length > 0) {
          this.$nextTick(() => {
            let eles = window.document.getElementsByClassName('time-line-box')
            let length = eles.length
            for (let i = 0; i < length; i++) {
              let min = eles[i].offsetTop
              let max = eles[i].offsetHeight + eles[i].offsetTop
              this.eleListData.push({ min, max })
            }
            this.i = this.i + 1
          })
        }
      }).catch(err => {
        this.loading = false
        this.noMore = true
      })
    },
    groupData(data) {
      let tempKey = {};
      let porjectId = {}
      let timeObj = {}
      data.forEach(item => {
        let key = item.create_time ? item.create_time.split(' ')[0] : ''
        if (tempKey[key]) {
          tempKey[key].push(item);
        } else {
          tempKey[key] = [item];
        }
        porjectId[key] = item.project.title
      });
      let objKeys = Object.keys(tempKey);
      this.time = []
      objKeys.forEach(item => {
        this.time.push(item)
        tempKey[item].forEach(res => {
          if (timeObj[item]) {
            if (timeObj[item][res.project.title]) {
              timeObj[item][res.project.title].push(res)
            } else {
              timeObj[item][res.project.title] = [res]
            }
          } else {
            timeObj[item] = {}
            timeObj[item][res.project.title] = [res]
          }
        })

      });
      return timeObj;
    },
    loadMore() {
      if (this.loading || this.noMore) {
        return
      }
      this.page = this.page + 1;
      return this.fetchDynamicList();
    },
    selectNode(index) {
      this.idx = index * 1
      this.isCheck = true
      let val = this.eleListData[index].min - 80;
      val < 0 ? val = 0 : true
      let ele = document.getElementsByClassName('el-card')[0]
      let newScr = ele.scrollTop
      let addVal = val - newScr
      let step = 0;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (addVal < 0) {
          if (ele.scrollTop <= val) {
            ele.scrollTop = val
            clearInterval(this.timer);
            this.isCheck = false
            return
          } else {
            step += 10;
            ele.scrollTop -= step;
          }
        } else {
          if (ele.scrollTop >= val) {
            ele.scrollTop = val
            clearInterval(this.timer);
            this.isCheck = false
            return
          } else {
            step += 10;
            ele.scrollTop += step;
          }
        }
      }, 20);
      // document.getElementsByClassName('content')[0].scrollTop = this.eleListData[index].min - 10;
    },
    async reset() {
      this.dataList = []
      this.loading = false
      this.noMore = false
      await this.fetchDynamicList()
      this.loadMore()
    },
    timeChange(val) {
      this.start_time = val[0]
      this.end_time = val[1]
      this.reset()
    },
    projectChange(val) {
      this.project_id = val
      this.reset()
    }
  }
};
</script>
<style lang="scss" src="./style.scss">
</style>
